import { render, staticRenderFns } from "./VectorItem.vue?vue&type=template&id=7f548e89&scoped=true"
import script from "./VectorItem.vue?vue&type=script&lang=js"
export * from "./VectorItem.vue?vue&type=script&lang=js"
import style0 from "./VectorItem.vue?vue&type=style&index=0&id=7f548e89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f548e89",
  null
  
)

export default component.exports